
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/manager",
      function () {
        return require("private-next-pages/candidate/manager/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/manager"])
      });
    }
  